<template>
  <div class="search-page-recommend">
    <div class="history-panel" v-if="historyList.length">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <div style="font-size: 0.4rem; color: #404040; font-weight: bold;">历史搜索</div>
        <div @click="clear">
          <div style="height: 0.43rem"><img src="/static/icon/delete-grey.png" alt="" style="width: 0.43rem; height: 0.43rem;" /></div>
        </div>
      </div>
      <div class="hisTab">
        <div v-for="(item, index) in historyList" :key="index" class="tabs" @click="search(item)">{{ item }}</div>
      </div>
    </div>
    <div class="hd">
      <span class="title">搜索发现</span>
      <img class="icon" :class="{ loading: refreshLoading }" src="/static/icon/refresh.png" alt="" @click="getSearchDiscoveryList">
    </div>
    <div class="bd">
      <div class="recommend-list">
        <div v-for="(item, index) in recommendList" :key="index" class="recommend-item" @click="handleRecommendItemClick(item)">{{ item.display_name ? item.display_name.replace(/<\/?[^>]*>/g, '') : '' }}</div>
      </div>
      <div class="recommend-banner">
        <cSwiperSec :bannerType="3" v-if="bannerList.length > 0" :list="bannerList" style="width: 100%; height: 4rem" :setPiontData="{hinaName: 'EV_SEARCH_BANNER'}"></cSwiperSec>
      </div>
    </div>
  </div>
</template>
<script>
import MaskBannerApis from '@/apis/maskservice/MaskBannerApis'
import { getRecommendList } from '@/apis/newdytapi/special-diseases-api'
export default {
  name: 'SearchPageRecommend',
  data() {
    return {
      historyList: [],
      recommendList: [],
      bannerList: [],
      refreshLoading: false,
    }
  },
  created () {
    this.historyList = JSON.parse(localStorage.getItem('serachValue')) || []
  },
  methods: {
    clear() {
      this.$dialog.confirm({
        message: '确定清空搜索记录吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        localStorage.removeItem('serachValue')
        this.historyList = []
      }).catch(() => {
        // on cancel
      })
    },
    search(item) {
      this.$emit('search', item)
    },
    getSwiperList() {
      let vm = this
      const BANNER_TYPE = 56
      MaskBannerApis.getBanners({ type: BANNER_TYPE })
        .then((res) => {
          vm.bannerList = res.data
        })
        .catch(function (e) { })
    },
    async getSearchDiscoveryList () {
      const MAX_COUNT = 8
      const BIZ_TYPE = 218
      this.refreshLoading = true
      try {
        const res = await getRecommendList({
          biz_type: BIZ_TYPE,
          current: 1,
          size: 10000
        })
        const list = res.data.hospital_list || []
        if (list.length <=  MAX_COUNT) {
          this.recommendList = list
        } else {
          // 随机取5个
          const indexArr = [];
          // eslint-disable-next-line no-constant-condition
          while(true) {
            const index = Math.floor(Math.random() * list.length);
            if (!indexArr.includes(index)) {
              indexArr.push(index);
            }
            if (indexArr.length >= MAX_COUNT) {
              break;
            }
          }
          this.recommendList = indexArr.map((index) => list[index])
        }
      } catch (error) {
        console.error('获取搜索发现列表失败', error);
      }
      this.refreshLoading = false
    },
    handleRecommendItemClick (item) {
      console.log(item)
      this.hina.track('EV_SEARCH_KEYWORDS_CLICK', {
        search_keyword: item.display_name,
        adv_keyword_id: item.recommend_id,
        adv_url: item.redirect_url
      })
      const url = item.redirect_url
      if (!url) {
        this.$toast('未配置链接')
        return
      }
      if(url.startsWith('http')) {
        window.location.href = url
      } else {
        this.$router.push(url)
      }
    }
  },
  mounted () {
    this.getSwiperList()
    this.getSearchDiscoveryList()
  }
}
</script>
<style lang="less" scoped>
@keyframes rolling {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.hisTab {
  display: flex;
  flex-wrap: wrap;
  margin: 0.55rem 0;
  overflow: hidden;
}
.tabs {
  border-radius: 13px;
  padding: 0 10px;
  text-align: center;
  margin-bottom: 10px;
  margin-right: 10px;
  border: solid 1px #DCDCDC;
  height: 26px;
  line-height: 26px;
}
.search-page-recommend {
  .hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .title {
      font-size: 0.4rem;
      color: #404040;
      font-weight: bold;
    }
    .icon {
      width: 0.43rem;
      height: 0.43rem;
      &.loading {
        animation: rolling 1s ease-in-out infinite;
      }
    }
  }
  .bd {
    .recommend-list {
      display: flex;
      flex-wrap: wrap;
      .recommend-item {
        border-radius: 13px;
        padding: 0 10px;
        text-align: center;
        margin-bottom: 10px;
        margin-right: 10px;
        border: solid 1px #DCDCDC;
        height: 26px;
        line-height: 26px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      margin-bottom: 30px;
    }
  }
}
</style>
